// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2u3oz","tab":"Tabs_tab__3Cgt2","tabActive":"Tabs_tabActive__1SfzL"};